export default class AdminLogsHeadersUpdate {
  label() {
    return I18n.t("js.admin.logs.headers.update.update")
  }
}
